(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  if ( window.innerWidth < 990 ) {
    let lastScrollTop = 0
    const header = document.querySelector('.site-header');
    const headerHeight = header.clientHeight;
  
    window.addEventListener('scroll',function(event){
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if ( scrollTop > headerHeight && scrollTop > lastScrollTop) {
        header.classList.add('is-fixed');
        header.classList.remove('reveal');
      } else if ( scrollTop < lastScrollTop && scrollTop > headerHeight ) {
        header.classList.add('reveal');
      } else if ( scrollTop < headerHeight ) {
        header.classList.remove('is-fixed');
        header.classList.remove('reveal');
      }
  
      lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; 
    }, false);
  }

    const hasAnnouncementBar = document.querySelector('.site-header.has-announcement');
    if (hasAnnouncementBar) {
      const announcementBar = document.querySelector('.header__main .announcement-bar');
      const announcementBarHeight = announcementBar.clientHeight;
      document.body.style.paddingTop = announcementBarHeight + 'px';
    }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-header"]) return;
  try {
    
  if ( window.innerWidth < 990 ) {
    let lastScrollTop = 0
    const header = document.querySelector('.site-header');
    const headerHeight = header.clientHeight;
  
    window.addEventListener('scroll',function(event){
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if ( scrollTop > headerHeight && scrollTop > lastScrollTop) {
        header.classList.add('is-fixed');
        header.classList.remove('reveal');
      } else if ( scrollTop < lastScrollTop && scrollTop > headerHeight ) {
        header.classList.add('reveal');
      } else if ( scrollTop < headerHeight ) {
        header.classList.remove('is-fixed');
        header.classList.remove('reveal');
      }
  
      lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; 
    }, false);
  }

    const hasAnnouncementBar = document.querySelector('.site-header.has-announcement');
    if (hasAnnouncementBar) {
      const announcementBar = document.querySelector('.header__main .announcement-bar');
      const announcementBarHeight = announcementBar.clientHeight;
      document.body.style.paddingTop = announcementBarHeight + 'px';
    }


  } catch(e) { console.error(e); }
})();
})();
